export default __webpack_public_path__ + "static/media/poster22.6ce858d5.png";